export default {"src":"/_next/static/media/IAC.97950c3e.svg","height":18,"width":18};